import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../config/authaxios";

const initialState = { status: null, data: [], loading: false, message: '' };

export const unlinkCategoryAction = createAsyncThunk(
  "unlink-category",
  async (data = null, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/admin/link/product-with-category`, {
        ...data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const unlinkCategorySlice = createSlice({
  name: "unlink-category",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(unlinkCategoryAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(unlinkCategoryAction.fulfilled, (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
      state.status = action.payload.status_code;
      if(state.status==401){
        localStorage.clear()
      }
      state.data = action.payload?.response;
    });
    builder.addCase(unlinkCategoryAction.rejected, (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
      state.status = action.payload.status_code;
      state.error = action.error.message;
    });
  },
});

export const unlinkCategoryReducer = unlinkCategorySlice.reducer;
